// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper__lGtwK","inputField":"Radio_inputField__sjLNL","label":"Radio_label__fCRfg","light":"Radio_light__Wua79"};